<div class="p-modal-head02">
  <h1
    *ngIf="pageTitleKey"
    id="modalTitle"
    class="c-message-box__title c-message-box__title--em"
    [innerHTML]="pageTitleKey | staticMsg"
  ></h1>
</div>
